"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const PageCardInformation = ({ icon, children, tooltip, onHover }) => {
    return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { content: tooltip, position: tooltip_1.default.TOOLTIP_POSITION.TOP, children: (0, jsx_runtime_1.jsxs)("span", { className: "_text_gray-500 _text-1", onMouseEnter: onHover, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: "_mr-1" }), children] }) }));
};
exports.default = PageCardInformation;
